<script setup lang="ts">
import type { LegalSourceRelation } from "~/types/article"

defineProps({
  note: {
    type: Object as PropType<LegalSourceRelation>,
    required: true,
  },
})
</script>

<template>
  <USidenote :note="note" title-class="text-teal-dark">
    <template #sidenoteType>
      <span>
        |
        {{ note.resource.type }} <br />
        <span> {{ note.resource.typeDescription }}</span>
      </span>
    </template>
    <template #tag
      ><span
        v-if="note.resource.paragraphAndSection"
        class="px-2.5 py-1 text-white bg-teal-dark rounded-md w-fit font-extrabold"
        >{{ note.resource.paragraphAndSection }}</span
      ></template
    >
    <template #url>
      <a
        v-if="note.resource.url"
        class="flex flex-wrap gap-2"
        :href="note.resource.url"
        target="_blank"
      >
        <span
          class="text-[font:inherit] underline decoration-grey-60 decoration-2 underline-offset-4 text-portal-indigo-600"
          >{{ note.resource.urlTitle }}</span
        >
        <UIcon
          class="self-center inline-block"
          name="link-external"
          size="md"
        />
      </a>
    </template>
    <template #content>
      <div v-html="note.resource.text" />
    </template>
  </USidenote>
</template>
